import { Typography } from '@analytical-alley/ui';
import { currencyFormat } from '@/dashboards/CompetitorsMediaInvestment/helpers/currencyFormat';

export type AreaTooltipProps = {
    seriesName: string;
    color: string;
    value: number;
    axisValueLabel: string;
}[];

export const AreaTooltip = ({
    params,
    selectedSeriesName,
    contributionFormatter,
    clientName,
}: {
    params: AreaTooltipProps;
    selectedSeriesName?: string;
    clientName?: string;
    contributionFormatter: (value: number) => string;
}) => {
    if (!selectedSeriesName) {
        return null;
    }

    const hoveredItem = params.find(
        (param) => param.seriesName === selectedSeriesName,
    );

    if (!hoveredItem) {
        return null;
    }

    if (selectedSeriesName === 'KPI') {
        return (
            <div className="tooltip-content">
                <table>
                    <tbody>
                        {clientName && (
                            <tr>
                                <td className="pr-2">
                                    <Typography className="text-black dark:text-black">
                                        Client Name:
                                    </Typography>
                                </td>
                                <td>
                                    <Typography className="text-dark dark:text-dark">
                                        {clientName}
                                    </Typography>
                                </td>
                            </tr>
                        )}
                        <tr>
                            <td className="pr-2">
                                <Typography className="text-black dark:text-black">
                                    Period:
                                </Typography>
                            </td>
                            <td>
                                <Typography className="text-dark dark:text-dark">
                                    {params[0]?.axisValueLabel}
                                </Typography>
                            </td>
                        </tr>
                        <tr>
                            <td className="pr-2">
                                <Typography className="text-black dark:text-black">
                                    Client KPI:
                                </Typography>
                            </td>
                            <td>
                                <Typography className="text-dark dark:text-dark">
                                    {contributionFormatter(hoveredItem.value)}
                                </Typography>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        );
    }

    return (
        <div className="tooltip-content">
            <table>
                <tbody>
                    <tr>
                        <td className="pr-2">
                            <Typography className="text-black dark:text-black">
                                Competitor Name:
                            </Typography>
                        </td>
                        <td>
                            <Typography className="text-dark dark:text-dark">
                                {hoveredItem.seriesName}
                            </Typography>
                        </td>
                    </tr>
                    <tr>
                        <td className="pr-2">
                            <Typography className="text-black dark:text-black">
                                Period:
                            </Typography>
                        </td>
                        <td>
                            <Typography className="text-dark dark:text-dark">
                                {params[0]?.axisValueLabel}
                            </Typography>
                        </td>
                    </tr>
                    <tr>
                        <td className="pr-2">
                            <Typography className="text-black dark:text-black">
                                Competitor`s investment:
                            </Typography>
                        </td>
                        <td>
                            <Typography className="text-dark dark:text-dark">
                                {currencyFormat.format(hoveredItem.value)}
                            </Typography>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
};
